import { render } from "./OTextEditor.vue?vue&type=template&id=794da0f2&scoped=true"
import script from "./OTextEditor.vue?vue&type=script&lang=js"
export * from "./OTextEditor.vue?vue&type=script&lang=js"

import "./OTextEditor.vue?vue&type=style&index=0&id=794da0f2&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794da0f2"]])

export default __exports__